import { isDevEnv } from '../helpers/environment'

const sentryDsn =
  'https://1592b933fc6c44e5fbf5d77e77206a05@o4505917822205952.ingest.sentry.io/4505956977344512'
const bostadsratternaPartnerId = '5eb04b7921140a10832d61df'
const villaagarnaPartnerId = '62837c35b6fd4bd52ac1ace9'
const bostadsutvecklarePartnerId = '63510e1931fbb6ccce957230'
const riksforbundetEnskildaVagarId = '637e131bc812eb023e909d9f'
const freeSamfPartnerId = '60f03773578b2c6f779b6ca4'
const foreningsplusPartnerId = '69032d7753131432003dcadf'

interface Config {
  BASE_URL: string
  SENTRY_ENVIRONMENT: string
  DEBUG: boolean
  SENTRY_DSN: string
  BOSTADSRATTERNA_PARTNER_ID: string
  VILLAAGARNA_PARTNER_ID: string
  BOSTADSUTVECKLARE_PARTNER_ID: string
  RIKSFORBUNDET_ENSKILDA_VAGAR_ID: string
  FREE_SAMF_PARTNER_ID: string
  FORENINGSPLUS_PARTNER_ID: string
  DISABLE_STATUS_API: boolean
}

interface Environments {
  development: Config
  staging: Config
  production: Config
}

const Environments: Environments = {
  development: {
    BASE_URL: 'https://stagingapi.boappa.se',
    SENTRY_ENVIRONMENT: 'development',
    DEBUG: true,
    SENTRY_DSN: sentryDsn,
    BOSTADSRATTERNA_PARTNER_ID: bostadsratternaPartnerId,
    VILLAAGARNA_PARTNER_ID: villaagarnaPartnerId,
    BOSTADSUTVECKLARE_PARTNER_ID: bostadsutvecklarePartnerId,
    RIKSFORBUNDET_ENSKILDA_VAGAR_ID: riksforbundetEnskildaVagarId,
    FREE_SAMF_PARTNER_ID: freeSamfPartnerId,
    FORENINGSPLUS_PARTNER_ID: foreningsplusPartnerId,
    DISABLE_STATUS_API: true,
  },
  staging: {
    BASE_URL: 'https://stagingapi.boappa.se',
    SENTRY_ENVIRONMENT: 'staging',
    DEBUG: true,
    SENTRY_DSN: sentryDsn,
    BOSTADSRATTERNA_PARTNER_ID: bostadsratternaPartnerId,
    VILLAAGARNA_PARTNER_ID: villaagarnaPartnerId,
    BOSTADSUTVECKLARE_PARTNER_ID: bostadsutvecklarePartnerId,
    RIKSFORBUNDET_ENSKILDA_VAGAR_ID: riksforbundetEnskildaVagarId,
    FREE_SAMF_PARTNER_ID: freeSamfPartnerId,
    FORENINGSPLUS_PARTNER_ID: foreningsplusPartnerId,
    DISABLE_STATUS_API: true,
  },
  production: {
    BASE_URL: 'https://wapi.boappa.se',
    SENTRY_ENVIRONMENT: 'production',
    DEBUG: false,
    SENTRY_DSN: sentryDsn,
    BOSTADSRATTERNA_PARTNER_ID: bostadsratternaPartnerId,
    VILLAAGARNA_PARTNER_ID: villaagarnaPartnerId,
    BOSTADSUTVECKLARE_PARTNER_ID: bostadsutvecklarePartnerId,
    RIKSFORBUNDET_ENSKILDA_VAGAR_ID: riksforbundetEnskildaVagarId,
    FREE_SAMF_PARTNER_ID: freeSamfPartnerId,
    FORENINGSPLUS_PARTNER_ID: foreningsplusPartnerId,
    DISABLE_STATUS_API: false,
  },
}

const getConfig = (): Config => {
  if (isDevEnv()) {
    return Environments.development
  }
  return Environments.production
}

const config = getConfig()

export default config
